const commonMixin = {
    beforeRouteLeave(to, from, next) {
        if (to.name == 'findExhibitDetail' || to.name == 'findExhibitorDetail' || to.name == 'findExhibitDetail') {
            sessionStorage.setItem('pageInfo', JSON.stringify(this.$data))
        }
        next()
    },
    methods: {
        pageInit2() {
            let data = sessionStorage.getItem('pageInfo') || ''
            if(!data) {
                this.pageInit && this.pageInit()
                return
            }
            data = JSON.parse(sessionStorage.getItem('pageInfo'))
            for(let key in data) {
                this.$set(this.$data, key, data[key])
            }
            sessionStorage.removeItem('pageInfo')
        },
    }
}
export default commonMixin